import { useLiveStats } from '../hooks/useApi';

export default function LivePulse() {
  const { data: live } = useLiveStats();
  const status = live?.ingestStatus?.status;
  const active = status === 'pending' || status === 'running';

  return (
    <div className="flex items-center gap-2 text-sm">
      <span
        className={`h-2.5 w-2.5 rounded-full ${
          active ? 'bg-[var(--success)]' : 'bg-[var(--muted)]'
        } ${active ? 'animate-pulse' : ''}`}
        aria-hidden="true"
      />
      <span className="font-medium text-[var(--fg)]">
        {active ? 'Live ingest' : status ?? 'Idle'}
      </span>
    </div>
  );
}
